/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * ガス開通受付情報
 */
export interface Sgkb575aResGasProvisionacceptanceInfo {
    /** 
     * 申込受付日：日付YYYYMMDD
     */
    mshkmAceptYmd?: string;
    /** 
     * 作業予定日付：日付YYYYMMDD
     */
    workScddt?: string;
    /** 
     * 作業予定時間帯区分コード：半角英数混在
     */
    workTimezkbnCode?: string;
    /** 
     * 作業予定時間帯区分コード名称：全角半角混在
     */
    scheduledworktimezoneDivcdAname?: string;
    /** 
     * 作業年月日：日付YYYYMMDD
     */
    sgyYmd?: string;
    /** 
     * 作業終了時分：時間HHMM
     */
    sgyShryJfn?: string;
    /** 
     * 託送供給開始予定年月日：日付YYYYMMDD
     */
    tksKiykKishYtiYmd?: string;
    /** 
     * 託送供給契約終了年月日：日付YYYYMMDD
     */
    tksKiykShryYmd?: string;
    /** 
     * マッチング日：日付YYYYMMDD
     */
    matchingDate?: string;
    /** 
     * 廃止取次状態：半角英数混在
     */
    ablcomState?: string;
    /** 
     * 廃止取次状態名称：全角半角混在
     */
    ablcomStateAname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由１：半角英数混在
     */
    switchingAblcomNgreason1?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由１名称：全角半角混在
     */
    switchingAblcomNgreason1Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由２：半角英数混在
     */
    switchingAblcomNgreason2?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由２名称：全角半角混在
     */
    switchingAblcomNgreason2Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由３：半角英数混在
     */
    switchingAblcomNgreason3?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由３名称：全角半角混在
     */
    switchingAblcomNgreason3Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由４：半角英数混在
     */
    switchingAblcomNgreason4?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由４名称：全角半角混在
     */
    switchingAblcomNgreason4Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由５：半角英数混在
     */
    switchingAblcomNgreason5?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由５名称：全角半角混在
     */
    switchingAblcomNgreason5Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由６：半角英数混在
     */
    switchingAblcomNgreason6?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由６名称：全角半角混在
     */
    switchingAblcomNgreason6Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由７：半角英数混在
     */
    switchingAblcomNgreason7?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由７名称：全角半角混在
     */
    switchingAblcomNgreason7Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由８：半角英数混在
     */
    switchingAblcomNgreason8?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由８名称：全角半角混在
     */
    switchingAblcomNgreason8Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由９：半角英数混在
     */
    switchingAblcomNgreason9?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由９名称：全角半角混在
     */
    switchingAblcomNgreason9Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由１０：半角英数混在
     */
    switchingAblcomNgreason10?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由１０名称：全角半角混在
     */
    switchingAblcomNgreason10Aname?: string;
    /** 
     * 導管事業者受付番号：半角数字
     */
    doknjgyshAcceptancenumber?: string;
    /** 
     * 次回検針予定年月日：日付YYYYMMDD
     */
    jikaiKenshinScheduledyearmonthdate?: string;
    /** 
     * メーター型式：半角英数混在
     */
    metermodel?: string;
    /** 
     * メーター能力：半角数値(小数点あり)
     */
    meterAbility?: number;
    /** 
     * メーター番号：半角英数混在
     */
    meterNo?: string;
    /** 
     * メーター取付位置コード：半角英数混在
     */
    meterInstallationpositioncode?: string;
    /** 
     * メーター取付位置コード名称：全角半角混在
     */
    meterInstallationlocationCodeaname?: string;
    /** 
     * メーター内外コード：半角英数混在
     */
    meterinneroutercode?: string;
    /** 
     * メーター内外コード名称：全角半角混在
     */
    meterNaigaiCodeaname?: string;
    /** 
     * メーター指針値：半角数値(小数点なし)
     */
    meterShshnch?: number;
    /** 
     * 手数料対象フラグ：半角英数混在
     */
    feeTargetflag?: string;
    /** 
     * 手数料対象フラグ名称：全角半角混在
     */
    feeTargetFlganame?: string;
    /** 
     * 休日作業対象フラグ：半角英数混在
     */
    holidayoperationTargetflag?: string;
    /** 
     * 休日作業対象フラグ名称：全角半角混在
     */
    holidayoperationTargetFlganame?: string;
    /** 
     * 立会者区分コード：半角英数混在
     */
    taiperDivcd?: string;
    /** 
     * 立会者区分コード名称：全角半角混在
     */
    taiperDivCodeaname?: string;
    /** 
     * 新設前開栓ステータス：半角英数混在
     */
    priortonewconstructionTurnonSts?: string;
    /** 
     * 新設前開栓ステータス名称：全角半角混在
     */
    priortonewconstructionTurnonstatusAname?: string;
    /** 
     * 小売事業者（現小売）コード：半角英数混在
     */
    currentretailBusinessoperatorcode?: string;
    /** 
     * 変更後　需要家電話番号コード：半角英数混在
     */
    afJyuyokatelnocode?: string;
    /** 
     * 変更後　需要家電話番号（２）：電話番号(ハイフンと数値含む)
     */
    afDemandTel2?: string;
    /** 
     * 変更後　需要家電話番号（２）コード：半角英数混在
     */
    afJyuyokatelno2Code?: string;
    /** 
     * 変更後　需要家電話番号（３）：電話番号(ハイフンと数値含む)
     */
    afJyuyokatelno3?: string;
    /** 
     * 変更後　需要家電話番号（３）コード：半角英数混在
     */
    afJyuyokatelno3Code?: string;
    /** 
     * 契約変更日区分：半角英数混在
     */
    ctrchgDateDiv?: string;
    /** 
     * 契約変更日区分名称：全角半角混在
     */
    ctrchgDateDivAname?: string;
    /** 
     * 契約変更年月：日付YYYYMM
     */
    ctrchgYm?: string;
    /** 
     * 契約変更日付：日付YYYYMMDD
     */
    ctrChgDate?: string;
    /** 
     * 託送契約変更年月：日付YYYYMM
     */
    consignmentcontractHenkoyearmonthday?: string;
    /** 
     * 総合契約区分コード：半角英数混在
     */
    sogoCtrDiv?: string;
    /** 
     * 総合契約区分コード名称：全角半角混在
     */
    combinedcontractDivCodeaname?: string;
    /** 
     * 供給検討番号：全角英数混在
     */
    kyokyuconsiderationNo?: string;
    /** 
     * 単価表コード：半角英数混在
     */
    tankatableCode?: string;
    /** 
     * 持込機器有料取付フラグ：半角英数混在
     */
    customerownedequipmentNotfreeInstallationflag?: string;
    /** 
     * 持込機器有料取付フラグ名称：全角半角混在
     */
    customerownedequipmentNotfreeInstallationflagAname?: string;
    /** 
     * 持込機器無料取付フラグ：半角英数混在
     */
    customerownedequipmentFreeInstallationflag?: string;
    /** 
     * 持込機器無料取付フラグ名称：全角半角混在
     */
    customerownedequipmentFreeInstallationflagAname?: string;
    /** 
     * 取外機器有料取外フラグ：半角英数混在
     */
    removedequipmentNotfreeFlg?: string;
    /** 
     * 取外機器有料取外フラグ名称：全角半角混在
     */
    removedequipmentNotfreeAname?: string;
    /** 
     * 取外機器無料取外フラグ：半角英数混在
     */
    removedequipmentFreeFlg?: string;
    /** 
     * 取外機器無料取外フラグ名称：全角半角混在
     */
    removedequipmentFreeAname?: string;
    /** 
     * 託送契約最大払出ガス量：半角数値(小数点なし)
     */
    consignmentcontractMaxExhaustgas?: number;
    /** 
     * 託送契約年間託送供給量：半角数値(小数点なし)
     */
    consignmentcontractNknTakusosupply?: number;
    /** 
     * 機器改造有無フラグ：半角英数混在
     */
    kikimodificationEonflg?: string;
    /** 
     * 機器改造有無フラグ名称：全角半角混在
     */
    kikimodificationEonflgAname?: string;
    /** 
     * 需要家電話番号コード：半角英数混在
     */
    juyokatelnoCode?: string;
    /** 
     * 需要家電話番号コード名称：全角半角混在
     */
    juyokatelnoCodeAname?: string;
    /** 
     * 需要家電話番号（２）：電話番号(ハイフンと数値含む)
     */
    juyokatelnoSeconde?: string;
    /** 
     * 需要家電話番号（２）コード：半角英数混在
     */
    juyokatelnoSecondecode?: string;
    /** 
     * 需要家電話番号（２）コード名称：全角半角混在
     */
    juyokatelnoSecondeCodeAname?: string;
    /** 
     * 需要家電話番号（３）：電話番号(ハイフンと数値含む)
     */
    juyokatelnoThird?: string;
    /** 
     * 需要家電話番号（３）コード：半角英数混在
     */
    juyokatelnoThirdcode?: string;
    /** 
     * 需要家電話番号（３）コード名称：全角半角混在
     */
    juyokatelnoThirdCodeAname?: string;
    /** 
     * 開栓種別コード：半角英数混在
     */
    turnonClscode?: string;
    /** 
     * 開栓種別コード名称：全角半角混在
     */
    turnonclsfyAname?: string;
    /** 
     * 作業拠点コード：半角英数混在
     */
    workBasecode?: string;
    /** 
     * 閉栓種別コード：半角英数混在
     */
    heisenClscode?: string;
    /** 
     * 閉栓種別コード名称：全角半角混在
     */
    heisenClsfyCodeaname?: string;
    /** 
     * 使用場所住所変更フラグ：半角英数混在
     */
    employmentpositionaddresscodeChangeflag?: string;
    /** 
     * 使用場所住所変更フラグ名称：全角半角混在
     */
    employmentpositionaddresscodeChangeflagAname?: string;
    /** 
     * 使用場所住所コード：半角英数混在
     */
    empposAddrcd?: string;
    /** 
     * 使用場所郵便番号：半角数字
     */
    empposPostno?: string;
    /** 
     * 使用場所都道府県名称：全角文字
     */
    empposPfcAname?: string;
    /** 
     * 使用場所市区郡町村名称：全角文字
     */
    empposMptAname?: string;
    /** 
     * 使用場所町域名称：全角文字
     */
    empposTwareaAname?: string;
    /** 
     * 使用場所大字丁目名称：全角文字
     */
    empposOazaAname?: string;
    /** 
     * 使用場所番地・号：全角文字
     */
    empposBuildingnumber?: string;
    /** 
     * 使用場所建物名：全角文字
     */
    empposTatemononame?: string;
    /** 
     * 使用場所目標変更フラグ：半角英数混在
     */
    enmploymentpositionaimChangeflag?: string;
    /** 
     * 使用場所目標変更フラグ名称：全角半角混在
     */
    enmploymentpositionaimChangeflagAname?: string;
    /** 
     * 使用場所目標：全角文字
     */
    empposAim?: string;
    /** 
     * 開閉栓状況：半角英数混在
     */
    openclosevalveJokyo?: string;
    /** 
     * 開閉栓状況名称：全角半角混在
     */
    openclosevalveJokyoAname?: string;
    /** 
     * スイッチ状態：半角英数混在
     */
    swState?: string;
    /** 
     * スイッチ状態名称：全角半角混在
     */
    swStateAname?: string;
    /** 
     * 供給先住所変更状態：半角英数混在
     */
    supplydestinationaddressChangestatus?: string;
    /** 
     * 供給先住所変更状態名称：全角半角混在
     */
    empamtUnitAname?: string;
    /** 
     * 託送契約月別託送供給量１月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyJan?: number;
    /** 
     * 託送契約月別託送供給量２月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyFeb?: number;
    /** 
     * 託送契約月別託送供給量３月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyMar?: number;
    /** 
     * 託送契約月別託送供給量４月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyApr?: number;
    /** 
     * 託送契約月別託送供給量５月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyMay?: number;
    /** 
     * 託送契約月別託送供給量６月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyJun?: number;
    /** 
     * 託送契約月別託送供給量７月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyJul?: number;
    /** 
     * 託送契約月別託送供給量８月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyAug?: number;
    /** 
     * 託送契約月別託送供給量９月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplySep?: number;
    /** 
     * 託送契約月別託送供給量１０月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyOct?: number;
    /** 
     * 託送契約月別託送供給量１１月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyNov?: number;
    /** 
     * 託送契約月別託送供給量１２月：半角数値(小数点なし)
     */
    consignmentcontractMonthlytakusosupplyDec?: number;
    /** 
     * お客さま名変更フラグ：半角英数混在
     */
    visitormeiChgFlg?: string;
    /** 
     * お客さま名変更フラグ名称：全角半角混在
     */
    visitormeiChangeflagAname?: string;
    /** 
     * お客さま名（カナ）変更フラグ：半角英数混在
     */
    visitnamekanaChgFlg?: string;
    /** 
     * お客さま名（カナ）変更フラグ名称：全角半角混在
     */
    visitnamekanaChangeflagAname?: string;
    /** 
     * お客さま電話番号１変更フラグ：半角英数混在
     */
    visittelno1ChgFlg?: string;
    /** 
     * お客さま電話番号１変更フラグ名称：全角半角混在
     */
    visittelno1ChangeflagAname?: string;
    /** 
     * お客さま電話番号２変更フラグ：半角英数混在
     */
    visittelno2ChgFlg?: string;
    /** 
     * お客さま電話番号２変更フラグ名称：全角半角混在
     */
    visittelno2ChangeflagAname?: string;
    /** 
     * お客さま電話番号３変更フラグ：半角英数混在
     */
    visittelno3ChgFlg?: string;
    /** 
     * お客さま電話番号３変更フラグ名称：全角半角混在
     */
    visittelno3ChangeflagAname?: string;
    /** 
     * 供給先住所変更結果：半角英数混在
     */
    supplydestinationaddressChangeresult?: string;
    /** 
     * 供給先住所変更結果名称：全角半角混在
     */
    supplydestinationaddressChangeresultAname?: string;
    /** 
     * 供給先番地・号変更結果：半角英数混在
     */
    supplydestinationBuildingnumberChangeresult?: string;
    /** 
     * 供給先番地・号変更結果名称：全角半角混在
     */
    supplydestinationBuildingnumberChangeresultAname?: string;
    /** 
     * 供給先建物名変更結果：半角英数混在
     */
    supplydestinationbuildingnameChangeresult?: string;
    /** 
     * 供給先建物名変更結果名称：全角半角混在
     */
    supplydestinationbuildingnameChangeresultAname?: string;
    /** 
     * 供給先目標変更結果：半角英数混在
     */
    supplydestinationAimChangeresult?: string;
    /** 
     * 供給先目標変更結果名称：全角半角混在
     */
    supplydestinationAimChangeresultAname?: string;
    /** 
     * 変更後　使用場所住所：全角文字
     */
    afEmploymentpositionaddresscode?: string;
    /** 
     * 変更後　使用場所番地・号：全角文字
     */
    afEnmploymentpositionblockgou?: string;
    /** 
     * 変更後　使用場所番地・号（カナ）：全角英数カナ
     */
    afEnmploymentpositionblockgouKana?: string;
    /** 
     * 変更後　使用場所建物名：全角文字
     */
    afEnmploymentpositionbuildingname?: string;
    /** 
     * 変更後　使用場所建物名（カナ）：全角英数カナ
     */
    afEnmploymentpositionbuildingnameKana?: string;
    /** 
     * 変更後　使用場所目標：全角文字
     */
    afEnmploymentpositionaim?: string;
    /** 
     * 変更後　使用場所目標（カナ）：全角カナ
     */
    afEnmploymentpositionaimKana?: string;
    /** 
     * 託送受付保留内容：全角文字
     */
    takusoacceptHoryucontents?: string;
    /** 
     * 閉栓作業担当者：全角半角混在
     */
    heisenWorkTntsh?: string;
}
